import Factory from 'factories/all';

export default function createEmailSendFailureItem(failure, agent) {
  return Factory.build('EmailSendFailureItem', {
    content: failure.content,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/communication_simulation_service/create_email_send_failure_item.js